import MuiCard from '@mui/material/Card';
import React from 'react';
export const Card = (props) => {
    const {themeType,...rest} = props;
    const cardComponent = (
        <MuiCard {...rest} />
    )
    return cardComponent;
};



export { default as CardContent } from '@mui/material/CardContent';
export { default as CardActions } from '@mui/material/CardActions';
export { default as CardHeader } from '@mui/material/CardHeader';